import { httpservice } from '../services';
import { constants } from '../constant/constant';

const resendVerification = (verificationMailToken) => httpservice()
  .get(`${constants.API.RESEND_VERIFICATION_MAIL}/${verificationMailToken}`)
  .then((response) => ({ status: 1, data: response.data }))
  .catch((error) => (error.response && error.response.data ? error.response.data : error));

export default resendVerification;
